import {colors, dimensions} from '@bettermarks/bm-ui-components';
import {
  Box,
  Icon,
  Link,
  Stack,
  useColorModeValue,
  useDisclosure,
  WrapItem
} from '@chakra-ui/react';
import {ReactNode, useEffect, useState} from 'react';
import {NavLink as RouterLink, useLocation} from 'react-router-dom';
import styled from 'styled-components';
import {css} from 'styled-components/macro';
import {RequireAtLeastOne} from '../types';

interface NavigationProps {
  menuItems: NavigationItemProps[];
}

export type NavigationItemProps = RequireAtLeastOne<
  {
    url: string;
    icon: any;
    label: string;
    active?: string;
    onClick?: () => void;
    badge?: any;
  },
  'url' | 'onClick'
>;

const compareUrl = (currPath: string, navLink: string) =>
  navLink
    .split('/')
    .filter(Boolean)[0]
    .startsWith(currPath.split('/').filter(Boolean)[0]);

export const NavigationItem = ({
  icon,
  label,
  url,
  onClick,
  badge
}: NavigationItemProps) => {
  const location = useLocation();
  const [cssClass, setClass] = useState<string>('');

  useEffect(() => {
    setClass(url && compareUrl(location.pathname, url) ? 'isActive' : '');
  }, [location.pathname]);
  const innerContent = (
    <>
      {icon && <Icon fontSize='20' as={icon} />}
      {label && <WrapItem as='span'>{label}</WrapItem>}
      {badge}
    </>
  );
  return (
    <>
      {(url && (
        <Link
          as={RouterLink}
          variant='navigation'
          className={cssClass}
          to={url}
          onClick={onClick}
          role='group'
          aria-label={label + ' Menüpunkt'}
        >
          {innerContent}
        </Link>
      )) || <Item {...((onClick && {onClick}) || {})}>{innerContent}</Item>}
    </>
  );
};

const navigationStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${dimensions.spaceXs} ${dimensions.spaceL};
  color: ${colors.cBlue700};
  cursor: pointer;
  font-size: ${dimensions.fontSizeS};
  position: relative;
`;

const Item = styled.a`
  ${navigationStyle}
`;

const NavLink = ({children}: {children: ReactNode}) => (
  <Link
    px={2}
    py={1}
    rounded={'md'}
    _hover={{
      textDecoration: 'none',
      bg: useColorModeValue('gray.200', 'gray.700')
    }}
    href={'#'}
  >
    {children}
  </Link>
);

const Links = ['Dashboard', 'Projects', 'Team'];

export const Navigation: React.FC<NavigationProps> = ({menuItems}) => {
  const {isOpen, onOpen, onClose} = useDisclosure();
  return (
    <>
      {/* <IconButton
          size={'md'}
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label={'Open Menu'}
          display={{md: 'none'}}
          onClick={isOpen ? onClose : onOpen}
        /> */}

      {menuItems.map((item: NavigationItemProps) => (
        <NavigationItem
          key={item.label}
          icon={item.icon}
          label={item.label}
          active={item.active}
          onClick={item.onClick}
          url={item.url}
          {...((item.badge && {badge: item.badge}) || {})}
        />
      ))}

      {isOpen ? (
        <Box pb={4} display={{md: 'none'}}>
          <Stack as={'nav'} spacing={4}>
            {Links.map(link => (
              <NavLink key={link}>{link}</NavLink>
            ))}
          </Stack>
        </Box>
      ) : null}
    </>
  );
};
